import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "inline-flex items-center justify-center !p-2 rounded-sm text-gray-400 bg-black hover:text-white hover:bg-gray-700 focus:outline-none",
  "data-test-menu-icon-wrapper": ""
}
const _hoisted_2 = {
  class: "relative flex-1 flex flex-col max-w-xs w-full bg-gray-900 focus:outline-none",
  "data-test-navigation-wrapper": ""
}
const _hoisted_3 = {
  class: "absolute top-0 right-0 -mr-12 pt-2",
  "data-test-close-button-wrapper": ""
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Close main menu", -1)
const _hoisted_5 = {
  class: "flex-1 h-0 pt-5 pb-4 overflow-y-auto",
  "data-test-navigation-links-wrapper": ""
}
const _hoisted_6 = {
  class: "flex items-center px-4 justify-start max-w-[16rem]",
  "data-test-company-logo-wrapper": ""
}
const _hoisted_7 = {
  "aria-label": "MainMenu",
  class: "mt-5"
}
const _hoisted_8 = ["aria-current", "href", "data-test-navigation-item", "onClick"]
const _hoisted_9 = { "data-test-navigation-item-name": "" }
const _hoisted_10 = {
  key: 0,
  class: "text-xs py-px inline-flex items-center group-hover:bg-gray-900 font-medium px-1.5 bg-gray-700 text-white rounded cursor-pointer",
  "data-test-anchor-label": ""
}
const _hoisted_11 = ["href"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  class: "flex-shrink-0 w-14",
  "aria-hidden": "true",
  "data-test-flex-shrink-element": ""
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MenuIcon = _resolveComponent("MenuIcon")!
  const _component_DialogOverlay = _resolveComponent("DialogOverlay")!
  const _component_TransitionChild = _resolveComponent("TransitionChild")!
  const _component_CloseIcon = _resolveComponent("CloseIcon")!
  const _component_CompanyLogo = _resolveComponent("CompanyLogo")!
  const _component_DesktopComputerIcon = _resolveComponent("DesktopComputerIcon")!
  const _component_AppBadge = _resolveComponent("AppBadge")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_ExternalLinkIcon = _resolveComponent("ExternalLinkIcon")!
  const _component_HeadlessUiDialog = _resolveComponent("HeadlessUiDialog")!
  const _component_TransitionRoot = _resolveComponent("TransitionRoot")!

  return (_openBlock(), _createElementBlock("div", {
    id: "main-menu-mobile",
    class: "p-2 cursor-pointer",
    "data-test-mobile-open-main-menu-element": "",
    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openMainMenu && _ctx.openMainMenu(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_MenuIcon, {
        class: "menu-icon block h-6 w-6",
        "aria-hidden": "true"
      })
    ]),
    _createVNode(_component_TransitionRoot, {
      as: "template",
      show: _ctx.mainMenuOpen
    }, {
      default: _withCtx(() => [
        _createVNode(_component_HeadlessUiDialog, {
          as: "div",
          class: "fixed inset-0 flex z-60 lg:hidden text-gray-300",
          onClose: _ctx.closeMainMenu
        }, {
          default: _withCtx(() => [
            _createVNode(_component_TransitionChild, {
              as: "template",
              enter: "transition-opacity ease-linear duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "transition-opacity ease-linear duration-300",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DialogOverlay, { class: "fixed inset-0 bg-gray-700 bg-opacity-80 backdrop-blur-px" })
              ]),
              _: 1
            }),
            _createVNode(_component_TransitionChild, {
              as: "template",
              enter: "transition ease-in-out duration-300 transform",
              "enter-from": "-translate-x-full",
              "enter-to": "translate-x-0",
              leave: "transition ease-in-out duration-300 transform",
              "leave-from": "translate-x-0",
              "leave-to": "-translate-x-full"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_TransitionChild, {
                    as: "template",
                    enter: "ease-in-out duration-300",
                    "enter-from": "opacity-0",
                    "enter-to": "opacity-100",
                    leave: "ease-in-out duration-300",
                    "leave-from": "opacity-100",
                    "leave-to": "opacity-0"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "ml-1 flex items-center justify-center h-10 w-10 rounded-sm focus:outline-none",
                          "data-test-close-button": "",
                          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeMainMenu && _ctx.closeMainMenu(...args)))
                        }, [
                          _hoisted_4,
                          _createVNode(_component_CloseIcon, {
                            class: "close-icon h-6 w-6 text-white",
                            "aria-hidden": "true"
                          })
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      (_ctx.company?.logoHtml.light)
                        ? (_openBlock(), _createBlock(_component_CompanyLogo, {
                            key: 0,
                            "logo-html": _ctx.company.logoHtml.light,
                            class: "max-h-16"
                          }, null, 8, ["logo-html"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("nav", _hoisted_7, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navigationItems, (navigationItem) => {
                        return (_openBlock(), _createBlock(_component_RouterLink, {
                          key: navigationItem.name,
                          to: navigationItem.href,
                          custom: ""
                        }, {
                          default: _withCtx(({ href, isActive }) => [
                            _createElementVNode("a", {
                              "aria-current": isActive ? 'page' : undefined,
                              class: _normalizeClass([_ctx.getNavigationItemDomClasses(navigationItem, isActive), "primary-nav-link px-3 py-4 rounded-t-sm whitespace-nowrap font-medium block text-sm"]),
                              href: href,
                              "data-test-navigation-item": navigationItem.name,
                              onClick: _withModifiers(() => _ctx.navigate(navigationItem), ["prevent"])
                            }, [
                              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t(navigationItem.name)), 1),
                              (_ctx.navigationItemIsAuthorTool(navigationItem))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                                    _createVNode(_component_DesktopComputerIcon, {
                                      class: "inline-block h-3 w-3 mr-1",
                                      "data-test-computer-icon": "",
                                      "aria-hidden": "true"
                                    }),
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('onlyAvailableOnDesktop')), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.mustShowSignDocumentsCount(navigationItem))
                                ? (_openBlock(), _createBlock(_component_AppBadge, {
                                    key: 1,
                                    size: "small",
                                    class: "bg-red-100 text-red-900 ml-1 !mb-0 float-right",
                                    "data-test-documents-badge": ""
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.user.signDocumentsCount), 1)
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ], 10, _hoisted_8)
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                      }), 128)),
                      (_ctx.user?.menuItems?.length)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.user.menuItems, (menuItem) => {
                            return (_openBlock(), _createElementBlock("a", {
                              key: `extra-mobile-menu-item-${menuItem.id}`,
                              href: menuItem.url,
                              target: "_blank",
                              class: "primary-nav-link block px-3 py-4 rounded-t-sm font-medium text-sm",
                              "data-test-extra-menu-item": ""
                            }, [
                              _createTextVNode(_toDisplayString(menuItem.title) + " ", 1),
                              _createVNode(_component_ExternalLinkIcon, { class: "inline-block relative -top-1 h-3.5 w-3.5" })
                            ], 8, _hoisted_11))
                          }), 128))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]),
              _: 1
            }),
            _hoisted_12
          ]),
          _: 1
        }, 8, ["onClose"])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}